import React from 'react'
import { Button } from '../../../buttons/default'
import { Modal } from '../../../modals/default'
import { LinkOutlined, GlobalOutlined } from '@ant-design/icons'

export interface Props {
  links: string[]
}

export function WebLinksCell({ links }: Props) {
  const [isModalOpen, setIsModalOpen] = React.useState(false)

  if (links.length === 0) {
    return <span style={{ color: '#999' }}>N/A</span>
  }

  const handleOpenModal = () => setIsModalOpen(true)
  const handleCloseModal = () => setIsModalOpen(false)

  const groupedLinks = links.reduce(
    (acc, link) => {
      try {
        const url = new URL(link)
        const domain = url.hostname.replace('www.', '')
        if (!acc[domain]) {
          acc[domain] = []
        }
        acc[domain].push(link)
      } catch {
        if (!acc['Other']) {
          acc['Other'] = []
        }
        acc['Other'].push(link)
      }
      return acc
    },
    {} as Record<string, string[]>,
  )

  return (
    <>
      <Button type='text' icon={<GlobalOutlined />} onClick={handleOpenModal} style={{ padding: 0, height: 'auto' }}>
        {links.length} link{links.length === 1 ? '' : 's'}
      </Button>

      <Modal title='Web links' open={isModalOpen} onCancel={handleCloseModal} footer={null} width={600}>
        <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
          {Object.entries(groupedLinks).map(([domain, domainLinks]) => (
            <div key={domain} style={{ marginBottom: 24 }}>
              <h4
                style={{
                  margin: '0 0 12px 0',
                  color: '#1890ff',
                  fontSize: '14px',
                  fontWeight: 600,
                }}
              >
                {domain} ({domainLinks.length})
              </h4>
              <div
                style={{
                  paddingLeft: 16,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '0.25rem',
                }}
              >
                {domainLinks.map((link, index) => (
                  <Button
                    style={{ justifyContent: 'start' }}
                    key={index}
                    color='default'
                    variant='filled'
                    href={link}
                    icon={<LinkOutlined />}
                  >
                    {link}
                  </Button>
                ))}
              </div>
            </div>
          ))}
        </div>
      </Modal>
    </>
  )
}
